import { h } from 'preact'

/* eslint-disable import/no-internal-modules */
import Icon from '@insided/deprecated-preact-components/assets'
import InputGroup from '@insided/deprecated-control/ui-components/InputGroup'
import Textarea from '@insided/deprecated-control/ui-components/Textarea'

import Modal from '../../../../../components/reactModal'
import { EscalationModalProps } from '../interfaces'
import { ModalActionButtons, ModalTitle } from '../ModalComponents'

const CreateEscalationModal = ({ modalTitle = '', modalTitleImage = '', isOpen, closeModal, onSubmit, title, username, onChangeCallback, content, onContentChange, titleValidationError, contentValidationError, onTextareaFocus, onClickCallback, isLoading }: EscalationModalProps) => {
  const hasContentValidationError = contentValidationError !== undefined
  return (
    <Modal isOpen={isOpen} onClose={() => closeModal()}>
      <div className='integration__create_ticket_modal integration__escalate_modal'>
        <ModalTitle title={modalTitle} imageName={modalTitleImage} />
        <div className='modal-description'>
          <div className='modal-user-email-field modal-data'>
            <label>Requester</label>
            <div>{username}</div>
          </div>
          <div className='modal-post-title-field modal-data'>
            <InputGroup
              title='Subject'
              key='post-title'
              required
              qaClasses='qa-post-title'
              value={title}
              error={titleValidationError}
              onChangeCallback={(e: ChangeEvent) => onChangeCallback(e.target.value)}
              onClick={() => onClickCallback()}
              showIconBeforeErrorMessage
            />
          </div>
          <label>Public Reply</label>
          <div className='modal-post-content-field modal-data'>
            <Textarea
              adjustHeight
              verticalResize
                // eslint-disable-next-line @gorazdo/preact/prefer-classname
              class='modal-post-content'
              newStyle
              onContentChange={(value: string) => onContentChange(value)}
              value={content?.replace(/<[^>]*>?/gm, ' ') ?? ''}
              error={hasContentValidationError}
              onTextareaFocus={() => onTextareaFocus()}
            />
            {hasContentValidationError && <div className='error-message-container'>
              <div><Icon customClass='icon-warning' icon='warning' /></div>
              <div className='error-message-text'>Please fill in the required field</div>
            </div>}
          </div>
        </div>
        <ModalActionButtons onSubmit={() => onSubmit()} isLoading={isLoading} closeModal={() => closeModal()} />
      </div>
    </Modal>
  )
}

export default CreateEscalationModal
